module.exports = __webpack_public_path__ + "img/icon1.37a1526f.svg";